// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "5fe0f78/js/" + chunkId + ".js";
};